import Text from 'components/_UI/Text'
import React from 'react'
import styled from 'styled-components';
import { Column } from 'styled/alignment/Column'
import { Row } from 'styled/alignment/Row';
import colors from 'theme/colors';
import { useNavigate } from 'react-router-dom';
import Icon from 'components/_UI/Icon';


export default function DeleteAccount() {
    const navigate = useNavigate();

    function goBack() {
        navigate(-1)
    }

    return (
        <Column
            paddingLeft='30px'
            paddingRight='30px'
            paddingTop='20px'
        >

            <StyledRow >
                <ContenButtonBack
                    onClick={goBack}
                >
                    <StyledButton>
                        <Icon name='back' />
                    </StyledButton>
                    <Text>Voltar</Text>
                </ContenButtonBack>
            </StyledRow>

            <Text name='title'>Exclusão de conta</Text>

            <Text>Você pode solicitar a exclusão da sua conta Whizr e dos seus dados pessoais a qualquer momento, diretamente pelo aplicativo.</Text>

            <Text
                name='highlight'
                marginTop='20px'
            >
                Como excluir sua conta
            </Text>

            <ul>
                <li>
                    <Text>Abra o aplicativo Whizr e faça login na sua conta;</Text>
                </li>
                <li>
                    <Text>Toque no ícone de Perfil;</Text>
                </li>
                <li>
                    <Text>Role até a opção <b>Excluir conta</b>;</Text>
                </li>
                <li>
                    <Text>Confirme a exclusão. Essa ação é irreversível e a conta é removida imediatamente.</Text>
                </li>
            </ul>

            <Text
                name='highlight'
                marginTop='20px'
            >
                O que acontece ao excluir sua conta
            </Text>

            <ul>
                <li>
                    <Text>Você perde acesso ao seu histórico de conta;</Text>
                </li>
                <li>
                    <Text>Você perde acesso às suas credenciais de login;</Text>
                </li>
                <li>
                    <Text>Você fica sem acesso a qualquer recurso de interação dentro da plataforma.</Text>
                </li>
            </ul>

            <Text
                name='highlight'
                marginTop='20px'
            >
                Dados excluídos e dados mantidos
            </Text>

            <Text>Ao excluir sua conta, removemos seus dados de perfil (nome, e-mail, documento, foto e localização salva) e suas credenciais de acesso. Registros de pedidos e transações já realizadas podem ser mantidos pelo período exigido pela legislação fiscal e tributária brasileira, mesmo após a exclusão da conta.</Text>

            <Text marginBottom={'40px'} marginTop='20px'>Dúvidas sobre a exclusão da sua conta ou dos seus dados podem ser enviadas para os canais de contato informados na nossa <b>Política de Privacidade</b>.</Text>

        </Column>
    )
}

const StyledRow = styled(Row)`
    width: 100%;
    justify-content: center;
`;

const ContenButtonBack = styled.div`
    display: flex;
    flex-direction: row;
    width: 80px;
    height: 40px;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    transition: all ease-in-out .25s;
    & > p {
        padding-bottom: 0px;
        font-size: 16px;
        margin-left: 5px;
        color: ${colors.primaryDashboard}
    }

    &:hover {
        transform: scale(1.02)
    }

`;

const StyledButton = styled(Row)`
    width: 26px;
    padding: 5px;
    height: 26px;
    border-radius: 50%;
`;
